import { createSlice } from "@reduxjs/toolkit";
import { getPaymentList } from "../services/payment-service";

const initialState = {
  payments: [],
  payment: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPaymentList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getPaymentList.fulfilled, (state, action) => {
        state.payments = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;

      })
      .addCase(getPaymentList.rejected, (state, action) => {
        state.loading = false;
      })

  },
});
export const { resetSuccess, resetState, resetError } = paymentSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export default paymentSlice.reducer;
